// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__20qKH","title":"Header_title__3LedJ","side":"Header_side__2NzQG"};